<template>
  <div>
    <b-card>
      <ValidationObserver ref="form" >
        <b-form @submit.prevent="onSubmit">
          <p class="text-danger">Poner 0 en max cuando la tarifa va a ser la mas alta</p>
          <Loading :active="loading" :is-full-page="true"></Loading>
          <div class="row">
            <div class="col-sm-6">
              <ValidationProvider name="Min" rules="required" v-slot="{ validated, valid }">
                <b-form-group
                  id="input-group-min"
                  label-for="min"
                  label="Min"
                  class="mb-0"
                >
                  <b-form-input v-model="selectedItem.sale" id="min" placeholder="Cantidad minima" :state="getState(validated, valid)"></b-form-input>
                </b-form-group>
              </ValidationProvider>
            </div>
            <div class="col-sm-6">
              <ValidationProvider name="Max" rules="required" v-slot="{ validated, valid }">
                <b-form-group
                  id="input-group-max"
                  label-for="max"
                  label="Max"
                  class="mb-0"
                >
                  <b-form-input v-model="selectedItem.sale_max" id="max" placeholder="Cantidad maxima" :state="getState(validated, valid)"></b-form-input>
                </b-form-group>
              </ValidationProvider>
            </div>
            <div class="col-sm-6">
              <ValidationProvider name="Porcentaje" rules="required" v-slot="{ validated, valid }">
                <b-form-group
                  id="input-group-percentage"
                  label-for="percentage"
                  label="Porcentaje"
                  class="mb-0"
                >
                  <b-form-input v-model="selectedItem.percentage" id="percentage" placeholder="Porcentaje" :state="getState(validated, valid)"></b-form-input>
                </b-form-group>
              </ValidationProvider>
            </div>
            <div class="col-sm-6">
              <ValidationProvider name="Terminal" rules="required" v-slot="{ validated, valid }">
                <b-form-group
                  id="input-group-terminal"
                  label-for="terminal"
                  label="terminal"
                  class="mb-0"
                >
                  <b-form-select
                    id="select-terminal"
                    class="form-control"
                    v-model="selectedItem.terminal"
                    :state="getState(validated, valid)"
                  >
                    <b-select-option v-for="p in terminals" :key="p" :value="p">{{p}}</b-select-option>
                  </b-form-select>
                </b-form-group>
              </ValidationProvider>
            </div>
          </div>
          <b-alert v-model="showDismissibleAlert" variant="danger" class="mt-4">
            <div v-if="errors" class="d-flex">
              <ul style="list-style-type:none;" class="p-0 m-0">
                <template v-for="(field, i) in errors">
                  <li v-for="(m, index) in field" :key="i+index" class="text-danger">{{ m }}</li>
                </template>
              </ul>
            </div>
          </b-alert>
        </b-form>
        <div class="w-100 mt-4">
          <b-button
            size="sm"
            class="float-left"
            :href="urlReturn()"
          >
            Cancelar
          </b-button>
          <b-button
            variant="primary"
            size="sm"
            class="float-right"
            @click="onSubmit"
          >
            Guardar
          </b-button>
        </div>
      </ValidationObserver>
    </b-card>
  </div>
</template>
<script>
  import { ValidationObserver, ValidationProvider, extend } from "vee-validate";
  import { required, email } from 'vee-validate/dist/rules'
  extend('email', email)
  extend('required', required)
  import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
  export default {
    name: 'ReservationsAdmin',
    props:['items'],
    components: {FontAwesomeIcon, ValidationObserver, ValidationProvider},
    data() {
      return {
        errors:null,
        loading:false,
        terminals:['T2','T3-T4',],
        infoModal: {
          id: 'info-modal',
          title: '',
          content: ''
        },
        selectedItem : {
          sale: '',
          sale_max: '',
          percentage: '',
          terminal: '',
        },
      }
    },
    
    mounted() {
      // Set the initial number of items
    },
    methods: {
      getState(validated, valid) {
        if (!validated) {
          return null;
        }
        return valid
      },
      urlReturn() {
        return `${process.env.MIX_APP_URL}${this.$prefixPanel}/commission-rates`
      },
      onSubmit(e) {
        e.preventDefault()
        this.errors = null
        this.updateSuccess = false
        this.$refs.form.validate().then((success) => {
          if (success) {
            this.loading = true
            const url = `${process.env.MIX_APP_URL}${this.$prefixPanel}/commission-rates/store`
            //this.$store.dispatch('quote/setRequest', this.rq)
            this.$axios.post(url, this.selectedItem).then(rs => {
              this.updateSuccess = true
              //this.loading = false
              this.$bvToast.toast(rs.data.message, {
                title: `Tarifa creada`,
                variant: 'success',
                solid: true,
                toaster: 'b-toaster-top-center',
              })
              location.href = this.urlReturn();
            })
            .catch(error=> {
              if (error.response) {
                this.errors = error.response.data.errors
              }  else {
                this.errors = {
                  unexpected: ['Hubo un error por favor contacte al administrador']
                }
              }
              console.log('error quote', error);
              this.loading = false
            })
          }
        })
      },
    },
    computed:{
      showDismissibleAlert() {
        return !(this.errors === null)
      }
    }
  }
</script>
